import createLucideIcon from '../createLucideIcon';

const SpellCheck = createLucideIcon('SpellCheck', [
  ['path', { d: 'm6 16 6-12 6 12', key: '1b4byz' }],
  ['path', { d: 'M8 12h8', key: '1wcyev' }],
  ['path', { d: 'm16 20 2 2 4-4', key: '13tcca' }],
]);

export default SpellCheck;
